// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"27":"65a6ad68","119":"bc2d9d72","288":"7dbf4712","348":"55235894","648":"6e17ec6a","751":"1f1b894e","787":"30237536","948":"a6c87529","980":"c2f969e4"}[chunkId] + ".chunk.js";
};